import { Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
    selector: "[click-out-directive]"
})
export class ClickOutDirective {
    @Output() isClickOutside: EventEmitter<boolean> = new EventEmitter<false>();
    constructor(
        private elementRef: ElementRef
    ) { }

    @HostListener("document:click", ["$event"])
    public clickout(event) {
        if (this.elementRef.nativeElement.contains(event.target)) {
            this.isClickOutside.emit(false);
        } else {
            this.isClickOutside.emit(true);
        }
    }
}